import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import { Box, Card, Theme } from "@mui/material";

export const StyledCard = styled(Card, { shouldForwardProp: prop => prop !== "hasMargin" && isPropValid(prop)})<{
  width: string | number;
  hasMargin: boolean;
  theme: Theme;
}>((props) => ({
  height: "440px",
  overflow: "auto",
  display: "inline-block",
  border: "rgba(0,0,0,0.5) solid 1px",
  width: props.width,
  margin: props.hasMargin ? props.theme.spacing(1) : "unset",
  borderRadius: "10px",
}));

export const StyledCardHeader = styled(Box)<{ theme: Theme }>((props) => ({
  position: "sticky",
  top: 0,
  backgroundColor: props.theme.palette.background.default,
  padding: props.theme.spacing(1.5),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const StyledCardBody = styled(Box)<{ theme: Theme }>((props) => ({
}));
